import { CustomEvents } from './CustomEvents';
// eslint-disable-next-line no-unused-vars
import { emit } from './EventsBus';

export default class GalleryManager {
  constructor(selectors, component, moduleLoader) {
    this.moduleLoader = moduleLoader;
    this.component = component;
    this.SELECTORS = selectors;
    this.itemsContainer = this.component.querySelector(
      this.SELECTORS.itemsContainer
    );
    this.items = this.component.querySelectorAll(this.SELECTORS.item);
    this.arrowRight = this.component.querySelector(this.SELECTORS.arrowRight);
    this.arrowLeft = this.component.querySelector(this.SELECTORS.arrowLeft);
    this.scroller = this.component.querySelector(this.SELECTORS.scroller);
    this.scrollerBox = this.component.querySelector(this.SELECTORS.scrollerBox);
    this.item = this.items[0];
    this.scrollIndex = 0;
    this.itemMargin = 0;
    this.offsetWidth = 0;
    if (this.scroller) {
      this.init();
    }
  }

  init() {
    //  observer
    this.simpleBarObserver();
    // Initially hide the left arrow
    if (this.arrowLeft) {
      this.arrowLeft.style.display = 'none';
    }

    this.itemMargin = parseInt(window.getComputedStyle(this.item).marginRight);
    this.offsetWidth = this.item.offsetWidth + this.itemMargin;
    if ( this.itemsContainer.offsetWidth >= 1192 || this.itemsContainer.offsetWidth > this.scroller.offsetWidth )
      this.arrowRight.style.display = 'flex';
    else
      this.arrowRight.style.display = 'none';
    this.calculateDimensions();

    this.moduleLoader.loadSimpleBarAndExecute(
      module => {
        this.initSimpleBar(module.default);
        this.bindEvents();
      },
      error => {
        console.log('failed to load SimpleBar ', error.stack);
      }
    );
  }


  bindEvents() {
    this.arrowRight.addEventListener('click', () => {
      if (this.scrollIndex == this.items.length - 1) return;
      this.scrollIndex++;
      var scroll = parseInt(
      this.scrollIndex * this.offsetWidth + this.scrollOffset,
      10
      );
      if (scroll - this.scroller.scrollLeft < this.offsetWidth / 2) {
        this.scrollIndex++;
        scroll = this.scrollIndex * this.offsetWidth + this.scrollOffset;
      }
      this.simpleBar
        .getScrollElement()
        .scrollTo({ left: scroll, behavior: 'smooth' });
      if (this.scrollIndex > this.maxIndex) {
        this.scrollIndex = this.maxIndex;
      }
    });

    this.arrowLeft.addEventListener('click', () => {
      if (this.scrollIndex <= 1) {
        this.simpleBar
          .getScrollElement()
          .scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      var scroll = this.scrollIndex * this.offsetWidth + this.scrollOffset;

      if (
        this.scrollIndex > 0 &&
        this.scroller.scrollLeft - scroll < this.offsetWidth / 2
      ) {
        this.scrollIndex--;
        scroll = this.scrollIndex * this.offsetWidth + this.scrollOffset;
      }

      this.simpleBar
        .getScrollElement()
        .scrollTo({ left: scroll, behavior: 'smooth' });
    });

    this.simpleBar.getScrollElement().addEventListener('scroll', e => {
      this.calculateDimensions();
      var scrollLeft = e.target.scrollLeft - this.scrollOffset;
      if (scrollLeft <= 0) {
        this.scrollIndex = 0;
        this.arrowLeft.style.display = 'none'; // Hide left arrow at the start
        return;
      }
        this.arrowLeft.style.display = 'flex'; // Show left arrow if not at the start

      this.scrollIndex = Math.ceil(scrollLeft / this.offsetWidth);
      if (e.target.offsetWidth + e.target.scrollLeft >= e.target.scrollWidth * .95) {
        this.arrowRight.style.display = 'none'; // Hide right arrow at the end
      } else {
        this.arrowRight.style.display = 'flex'; // Show right arrow if not at the end
      }
    });
  }

  simpleBarObserver() {
    // Dynamic init of callbacks to be launched
    // observer listener
    function listener(records) {
      records.forEach(function(record) {
        var list = record.addedNodes;
        var i = list.length - 1;
        for (; i > -1; i--) {
          // if i find a new element
          if (typeof list[i] == 'object' && list[i].nodeType == '1') {
            let node = list[i];
            if (node.querySelector('.simplebar-content') != null) {
              // simplebar founded and loaded
              emit(CustomEvents.SIMPLEBAR_EVENTS.loaded, { elem: node }, false);
            }
          }
        }
      });
    }
    // define observer
    let observer = new MutationObserver(listener);
    // get the observer
    let simpleBarNode = document.querySelector(this.SELECTORS.scroller);
    if (typeof simpleBarNode != 'undefined' && simpleBarNode != null) {
      // launch to observe node
      observer.observe(simpleBarNode, { childList: true, subtree: true });
    }
  }

  setSelectedItem(toBeSelected) {
    this.items.forEach(item => {
      if (item === toBeSelected) {
        item.classList.add(this.CSS_CLASSNAMES.selected);
      } else {
        item.classList.remove(this.CSS_CLASSNAMES.selected);
      }
    });
  }

  calculateDimensions() {
    var scrollContainerOffset = 0;
    try {
      scrollContainerOffset = parseInt(
        window.getComputedStyle(this.scroller).paddingLeft
      );
      this.scrollOffset =
        scrollContainerOffset -
        this.component.querySelector(this.SELECTORS.titleContainer).offsetWidth;
    } catch (e) {
      this.scrollOffset = 0;
    }
    this.maxIndex = Math.max(
      0,
      this.items.length -
        Math.ceil(
          (this.scroller.offsetWidth - scrollContainerOffset) / this.offsetWidth
        )
    );
  }

  initSimpleBar(SimpleBar) {
    this.simpleBar = new SimpleBar(this.scroller, {
      autoHide: false,
    });
  }
}
